import { Box } from "@mui/material";
import { Field } from "components";
import { zodResolver } from '@hookform/resolvers/zod';
import { LoadingButton } from "components/Shared/LoadingButton/LoadingButton";
import { forwardRef, useImperativeHandle } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { CONTACT_FORM_CHARS_MAX, contactFormValidation, IContactFormValidation } from "./ContactForm.config";

export type ContactFormRef = {
  resetValues: () => void;
};

interface IContactForm {
  onCompletedForm: (values: IContactFormValidation) => void;
  isLoading: boolean;
}

export const ContactForm = forwardRef<ContactFormRef, IContactForm>(({ onCompletedForm, isLoading }, ref) => {

  const methods = useForm<IContactFormValidation>({
    resolver: zodResolver(contactFormValidation),
  });

  const onSubmitHandler: SubmitHandler<IContactFormValidation> = (values) => {
    onCompletedForm(values);
  };

  useImperativeHandle(ref, () => ({
    resetValues: () => {
      methods.reset();
    }
  }));

  return (
    <FormProvider {...methods}>
      <Box
        component='form'
        noValidate
        autoComplete='off'
        onSubmit={methods.handleSubmit(onSubmitHandler)}
      >
        <Field.TextField
          name={"name"}
          label={"Nombre"}
          fieldColor={"black"}
        />
        <Field.TextField
          name={"surname"}
          label={"Apellido"}
          fieldColor={"black"}
        />
        <Field.TextField
          name={"email"}
          label={"Correo electrónico"}
          fieldColor={"black"}
        />
        <Field.TextField
          name={"message"}
          label={`Mensaje (máximo ${CONTACT_FORM_CHARS_MAX} carácteres)`}
          multiline={true}
          rows={10}
          fieldColor={"black"}
        />
        <LoadingButton isLoading={isLoading} label="Enviar" fullWidth type="submit" />
      </Box>
    </FormProvider>
  );
});
